module.exports = __webpack_public_path__ + "img/skb2.d28ab15a.jpg";